export enum TagTypes {
  'Error' = 'error',
  'Completed' = 'completed',
  'Pending' = 'pending',
  'Scheduled' = 'scheduled',
  'Inactive' = 'inactive',
  'Holiday' = 'holiday',
  'Maintenance' = 'maintenance',
  'NationalDealOptIn' = 'nationalDealOptIn',
  'NationalDealLive' = 'nationalDealLive',
  'UpchargeRequired' = 'requiresUpcharge',
}

export interface TagLink {
  text: string;
  onClick: () => void;
}

export interface TagProps {
  type?: TagTypes;
  label: string | JSX.Element;
  link?: TagLink;
  fullWidth?: boolean;
  className?: string;
  title?: string;
}
